






















import { Vue, Component, Prop } from 'vue-property-decorator';

import ProgramStatusTag from '@/componentsV2/atoms/ProgramStatusTag/ProgramStatusTag.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import Statistics from '../Statistics.vue';
import {
  IBusinessReferral,
  IBusinessReferralChart
} from '@/models/marketingCenter/referral';

@Component({ components: { Typography, Statistics, ProgramStatusTag } })
export default class CampaignStatistics extends Vue {
  @Prop() campaign!: IBusinessReferral;
  @Prop() chart!: IBusinessReferralChart;

  get legendProps() {
    return {
      horizontalAlign: 'left'
    };
  }

  gotoReferralDetail() {
    this.$router.push('/referral-program');
  }
}
